import React from "react";
import Head from "next/head";
import { NextSeo } from "next-seo";
import { seoFunct } from "../../config/next-seo.config.js";
import { withRouter } from "next/router";
import HomeNav from "../Home/HomeNav.jsx";
import HomeFooter from "../Home/HomeFooter.jsx";
import FeatureIntroComponent from "../../revampComponents/FeatureIntroComponent.js";
import FeaturesCard from "../../revampComponents/FeaturesCard.js";
import AppBanner from "../../revampComponents/Banner.js";
import revampData from "../../data/revampData.json";
const Developers = () => {
  const featureIntro = revampData.data.listDevelopersFeaturesIntroSections.data;
  const listDevelopersFeaturesData = revampData.data.listDevelopersFeaturesCards.data;
  const developerBanner = revampData.data.listDevelopersFeaturesCallToActionBanner.data;
  return <div className="font-figtree" data-sentry-component="Developers" data-sentry-source-file="Developers.jsx">
			<NextSeo {...seoFunct("revampDevelopersSeo")} data-sentry-element="NextSeo" data-sentry-source-file="Developers.jsx" />
			<HomeNav isBgNavyBlue={false} data-sentry-element="HomeNav" data-sentry-source-file="Developers.jsx" />
			<FeatureIntroComponent featureIntro={featureIntro} data-sentry-element="FeatureIntroComponent" data-sentry-source-file="Developers.jsx" />
			<FeaturesCard featuresData={listDevelopersFeaturesData} swapCard={true} data-sentry-element="FeaturesCard" data-sentry-source-file="Developers.jsx" />
			<AppBanner bannerData={developerBanner} data-sentry-element="AppBanner" data-sentry-source-file="Developers.jsx" />
			<HomeFooter data-sentry-element="HomeFooter" data-sentry-source-file="Developers.jsx" />

			<style jsx>{`
				.main-container {
					width: 100%;
				}
				* {
					font-family: "Figtree" !important;
				}
			`}</style>
		</div>;
};
export default withRouter(Developers);